var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5969 9.72123C26.3369 8.75523 25.5752 7.99357 24.6092 7.73349C22.8444 7.25049 15.7851 7.25049 15.7851 7.25049C15.7851 7.25049 8.72586 7.25049 6.96105 7.71491C6.01362 7.97499 5.23338 8.75523 4.97331 9.72123C4.50888 11.486 4.50888 15.1457 4.50888 15.1457C4.50888 15.1457 4.50888 18.824 4.97331 20.5702C5.23338 21.5362 5.99504 22.2979 6.96105 22.5579C8.74444 23.0409 15.7851 23.0409 15.7851 23.0409C15.7851 23.0409 22.8444 23.0409 24.6092 22.5765C25.5752 22.3164 26.3369 21.5548 26.5969 20.5888C27.0614 18.824 27.0614 15.1643 27.0614 15.1643C27.0614 15.1643 27.08 11.486 26.5969 9.72123Z",
    fill: "url(#paint0_linear_191_1569)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5373 18.3978L19.4077 15.0168L13.5373 11.6357V18.3978Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_191_1569",
    x1: 15.7852,
    y1: 7.25049,
    x2: 15.7852,
    y2: 23.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E9E99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenYoutube);
export default __webpack_public_path__ + "static/media/greenYoutube.82d0888c14e76b3d32b70a9be5693384.svg";
export { ForwardRef as ReactComponent };